module.exports = __webpack_public_path__ + "img/flag-icon-zh.b4c2fcb8.svg";